const closeOpenedDropdown = () => {
    if(document.querySelector(".dropdown.show > :first-child") !== null) {
        document.querySelector(".dropdown.show > :first-child").click();
    }
}

export default closeOpenedDropdown;